module.exports = __webpack_public_path__ + "assets/c003ed7f58d90fcfa0dd6789147f8bd3.png";